import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton, CircularProgress, Box } from "@mui/material";
import type { Breakpoint } from "@mui/material/styles";
import type { ReactNode } from "react";

export type StandardModalProps = {
  open: boolean;
  title: string;
  onClose: () => void;
  footer?: ReactNode;
  loading?: boolean;
  children: ReactNode;
  /** MUI Dialog `maxWidth`. Default `sm` (~600px) so forms fill the dialog without excess empty space. */
  maxWidth?: Breakpoint | false;
};

export function StandardModal({
  open,
  title,
  onClose,
  footer,
  loading,
  children,
  maxWidth = "sm",
}: StandardModalProps) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", pr: 1 }}>
        <span style={{ flex: 1 }}>{title}</span>
        <IconButton aria-label="close" onClick={onClose} disabled={loading} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ position: "relative", minHeight: 120 }}>
        {children}
        {loading ? (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "rgba(255,255,255,0.75)",
              zIndex: 1,
            }}
          >
            <CircularProgress size={28} />
          </Box>
        ) : null}
      </DialogContent>
      {footer ? <Box sx={{ px: 3, py: 2, borderTop: 1, borderColor: "divider" }}>{footer}</Box> : null}
    </Dialog>
  );
}
